import React from "react";

const Image = ({ src, imgClassName = "" }) => {
  if (src === null) {
    return <img src="/img/profile.png" className={imgClassName} />;
  } else {
    return <img src={src} className={imgClassName} />;
  }
};

export default Image;
